<div class="modal-header">
  <h5 class="modal-title text-primary">{{alertDialog.HeadingText}}</h5>
  <button class="fa fa-times text-primary" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body">
  <div class="overflow-x mt-3" style="width: 100%;">
    <div class="row">
      <div class="col-lg-4 text-primary">Upload Customer</div>
      <div class="col-lg-8">
        <input type="file" accept=".xls,.xlsx" (change)="handleFileInput($event.target.files)" class="form-control form-control-sm" />
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-sm btn-default" [mat-dialog-close]="">Cancel</button>
  <button class="btn btn-sm bg-g-lightGreen" *ngIf="alertDialog.IsAction" [mat-dialog-close]="fileToUpload"
    cdkFocusInitial>{{alertDialog.ActionButtonText}}</button>
</div>
